import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";
import "./ContactUs.css";

const ContactUs = () => {
  const contactItems = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Address",
      text: "3/3564, E Govindappa Building, Main Road, Puttaparthi, Andhra Pradesh – 515134",
      className: "address",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Phone",
      text: "+91 9849109978, 8247452209",
      className: "phone",
    },
    {
      icon: <FaEnvelope />,
      title: "Email",
      text: "sesaisurya999@gmail.com",
      className: "email",
    },
    {
      icon: <FaClock />,
      title: "Office Hours",
      text: "Everyday: 9:00 AM – 8:00 PM",
      className: "office-hours",
    },
  ];

  return (
    <div className="contact-container" id="contact-section">
      {/* Google Map */}
      <div className="map-hero">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15232.769521971538!2d77.808857!3d14.1659222!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbd2c9d32c8d161%3A0x0!2zMTTCsDA5JzU3LjMiTiA3N8KwNDgnNDEuMiJF!5e0!3m2!1sen!2sin!4v1708839200000!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="Sai Bhavana Realty Location"
        ></iframe>
      </div>

      {/* Contact Info */}
      <div className="contact-card">
        <h1 className="contact-title">Contact Us</h1>
        <p className="contact-intro">
          At Sai Bhavana Realty, we provide personalized, transparent, and professional real estate services. Reach out to us and we will guide you at every step.
        </p>

        <h2>Get in Touch</h2>
        <div className="contact-items">
          {contactItems.map((item, index) => (
            <div className="contact-item-card" key={index}>
              <div className={`icon-bg ${item.className}`}>
                {item.icon}
              </div>
              <div className="contact-text">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        <h2>Connect With Us</h2>
        <div className="social-links">
          <a href="https://www.facebook.com/share/1FuAp8FaRY/" target="_blank" rel="noopener noreferrer">
            <FaFacebookF /> Facebook
          </a>
          <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
            <FaInstagram /> Instagram
          </a>
        </div>

        <a
          href="https://wa.me/919849109978"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-button"
        >
          <FaWhatsapp /> Faster Contact? Get us on WhatsApp!
        </a>
      </div>
    </div>
  );
};

export default ContactUs;